import firebase from 'firebase';

const config = {
  apiKey: "AIzaSyBRhotYbiqkXpmccIvpjf4KrcrcN0z3B5Y",
  authDomain: "area52-344b5.firebaseapp.com",
  projectId: "area52-344b5",
  storageBucket: "area52-344b5.appspot.com",
  messagingSenderId: "401129590423",
  appId: "1:401129590423:web:1be168147630ce18b6a3d2",
  measurementId: "G-T7NV1TK8NY"
};
firebase.initializeApp(config);
export const auth = firebase.auth;
export const db = firebase.database();
